var map = {
	"./elevator-0.png": "6d88",
	"./elevator-1.png": "1288",
	"./elevator-2.png": "aedc",
	"./elevator-3.png": "c78a",
	"./elevator-4.png": "bb5a",
	"./elevator-5.png": "ff9e",
	"./elevator-undefined.png": "a8c9",
	"./screw-0.png": "07d4",
	"./screw-1.png": "c29c",
	"./screw-2.png": "e478",
	"./screw-3.png": "b268",
	"./screw-4.png": "f8e0",
	"./screw-5.png": "5155",
	"./screw-undefined.png": "a7d9",
	"./tank-0.png": "da3e",
	"./tank-1.png": "d806",
	"./tank-2.png": "1c88",
	"./tank-3.png": "179a",
	"./tank-4.png": "3784",
	"./tank-5.png": "d61a",
	"./tank-undefined.png": "dba6",
	"./transporter-0.png": "d0a1",
	"./transporter-1.png": "3327",
	"./transporter-2.png": "7804",
	"./transporter-3.png": "2f4e",
	"./transporter-4.png": "f923",
	"./transporter-5.png": "2a04",
	"./transporter-undefined.png": "ed7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";